import _ from 'lodash'

import config from '@config'

import {
    ASSIGNED_TENDERS_LOAD_PUBLISHERS_DATA,
    ASSIGNED_TENDERS_LOAD_PUBLISHERS_DATA_REQUEST,
    ASSIGNED_TENDERS_PUBLISHERS_TABLE_LOADING_TRUE,
    ASSIGNED_TENDERS_PUBLISHERS_TABLE_LOADING_FALSE,
    ASSIGNED_TENDERS_PUBLISHERS_TABLE_LOADING_FAILED,
    ASSIGNED_TENDERS_PUBLISHERS_TABLE_DATA_RECEIVED,
} from './constants'

export const loadPublishersData = (module, block, entId, level, tenderId) => ({
    type: ASSIGNED_TENDERS_LOAD_PUBLISHERS_DATA,
    data: {
        module,
        block,
        entId,
        level,
        tenderId,
    },
})

export const loadTableDataRequest = (module, block, entId, level, lang, token, tenderId, queryParams) => ({
    type: ASSIGNED_TENDERS_LOAD_PUBLISHERS_DATA_REQUEST(entId, tenderId),
    payload: {
        uri: _.get(config, `api.${module}.${block}.tables.publishedTendersPublishers.uri`),
        qs: {
            ...queryParams,
            entId,
            lang,
            token,
            level,
            procurementType: 'pub',
            procurementId: tenderId,
        },
        uriParams: {
            entId,
            lang,
        },
        headers: {
            'X-Token': token,
        },
    },
})

export const publishersTableLoadingTrue = (module, block, entId, level, tenderId, data) => ({
    type: ASSIGNED_TENDERS_PUBLISHERS_TABLE_LOADING_TRUE,
    data: {
        module,
        block,
        entId,
        level,
        tenderId,
        data,
    },
})

export const publishersTableLoadingFalse = (module, block, entId, level, tenderId, data) => ({
    type: ASSIGNED_TENDERS_PUBLISHERS_TABLE_LOADING_FALSE,
    data: {
        module,
        block,
        entId,
        level,
        tenderId,
        data,
    },
})

export const publishersTableLoadingFailed = (module, block, entId, level, tenderId, data) => ({
    type: ASSIGNED_TENDERS_PUBLISHERS_TABLE_LOADING_FAILED,
    data: {
        module,
        block,
        entId,
        level,
        tenderId,
        data,
    },
})

export const publishersTableDataReceived = (module, block, entId, level, tenderId, data) => ({
    type: ASSIGNED_TENDERS_PUBLISHERS_TABLE_DATA_RECEIVED,
    data: {
        module,
        block,
        entId,
        level,
        tenderId,
        data,
    },
})
